<section id="boxes">
  <div class="empty-space"></div>
  <div class="jobs" [dir]="'Direction' | translate">
    <div class="container" data-aos="fade-up" data-aos-duration="1000">
      <div class="section-box">
        <div>
          <span class="section-title" [dir]="'Direction' | translate">
            صناديق الاستثمار
          </span>
        </div>
        <div class="jobs-inner">
          <p class="intro-text">
            تدير شركة أيه أي إم للاستثمارات المالية صناديق استثمار اسباير كابيتال، وهي أدوات استثمارية مرخصة
            من الهيئة العامة للرقابة المالية، تتيح للمستثمر الاكتتاب والاسترداد يوميًا دون مصروفات إضافية.
          </p>

          <div class="funds-holder">
            <div class="fund-card" *ngFor="let item of displayItems" [class.simple-card]="!item.fund">

              <ng-container *ngIf="item.fund as fund; else simpleHeader">
                <div class="fund-card-header">
                  <h3>{{ fund.title }}</h3>
                  <span class="fund-subtitle">{{ fund.subtitle }}</span>
                  <span class="license-tag">{{ fund.licenseNo }}</span>
                </div>
              </ng-container>
              <ng-template #simpleHeader>
                <div class="fund-card-header">
                  <h3>{{ item.box.name }}</h3>
                </div>
              </ng-template>

              <div class="price-panel">
                <div class="price-panel-main">
                  <span class="price-label">السعر الحالي للوثيقة</span>
                  <div class="price-amount">
                    <span class="price-value">{{ item.box.currentPrice | number : '1.5-5' }}</span>
                    <span class="price-currency">جنيه مصري</span>
                  </div>
                </div>
                <span class="price-updated" *ngIf="item.box.updatedAt && (item.box.updatedAt | date : 'yyyy') !== '1'">
                  آخر تحديث: {{ item.box.updatedAt | date : 'dd/MM/yyyy' }}
                </span>
              </div>

              <div class="fund-notice" *ngIf="item.notice as notice" dir="rtl">
                <div class="fund-notice-header">
                  <span class="notice-badge">{{ notice.badge }}</span>
                  <h4>{{ notice.title }}</h4>
                </div>
                <p class="notice-body">{{ notice.body }}</p>
                <div class="notice-meta">
                  <div class="notice-meta-item" *ngFor="let meta of notice.meta">
                    <span class="meta-label">{{ meta.label }}</span>
                    <span class="meta-value">{{ meta.value }}</span>
                  </div>
                </div>
                <p class="notice-highlight">{{ notice.highlight }}</p>
              </div>

              <div class="history-chart" *ngIf="item.chartLoaded">
                <div class="chart-header">
                  <span class="section-subtitle chart-title">سجل الأسعار</span>
                  <div class="chart-range-buttons">
                    <button
                      *ngFor="let range of chartRanges"
                      type="button"
                      class="range-btn"
                      [class.active]="item.selectedRange === range.value"
                      (click)="setRange(item, range.value)">
                      {{ range.label }}
                    </button>
                  </div>
                </div>
                <div
                  class="chart-container"
                  [class.chart-scrollable]="item.chartScrollable"
                  (wheel)="onChartWheel($event, item)"
                  (mousedown)="onChartMouseDown($event, item)"
                  (mousemove)="onChartMouseMove($event)"
                  (mouseup)="onChartMouseUp()"
                  (mouseleave)="onChartMouseUp()">
                  <canvas baseChart
                    [datasets]="item.chartDatasets"
                    [labels]="item.chartLabels"
                    [options]="item.chartOptions"
                    type="line">
                  </canvas>
                </div>
                <span class="chart-scroll-hint" *ngIf="item.chartScrollable">اسحب أو مرّر داخل الرسم للتصفح</span>
              </div>

              <ng-container *ngIf="item.fund as fund">
                <p class="fund-objective">{{ fund.objective }}</p>

                <div class="fund-facts">
                  <div class="fact">
                    <span class="fact-label">طبيعة الصندوق</span>
                    <span class="fact-value">{{ fund.fundType }}</span>
                  </div>
                  <div class="fact">
                    <span class="fact-label">الجهة المصدرة</span>
                    <span class="fact-value">{{ fund.issuer }}</span>
                  </div>
                  <div class="fact">
                    <span class="fact-label">مدير الاستثمار</span>
                    <span class="fact-value">{{ fund.manager }}</span>
                  </div>
                  <div class="fact">
                    <span class="fact-label">القيمة الاسمية للوثيقة</span>
                    <span class="fact-value">{{ fund.nominalValue }}</span>
                  </div>
                  <div class="fact">
                    <span class="fact-label">الحد الأدنى للاكتتاب</span>
                    <span class="fact-value">{{ fund.minSubscription }}</span>
                  </div>
                </div>

                <h4 class="section-subtitle">الضوابط الاستثمارية</h4>
                <div class="allocation-list">
                  <div class="allocation-item" *ngFor="let allocationItem of fund.allocation">
                    <div class="allocation-row">
                      <span>{{ allocationItem.label }}</span>
                      <span>{{ allocationItem.value }}</span>
                    </div>
                    <div class="allocation-bar">
                      <div class="allocation-bar-fill" [style.width.%]="allocationItem.percent"></div>
                    </div>
                  </div>
                </div>

                <h4 class="section-subtitle">مزايا الصندوق</h4>
                <ul class="features-list">
                  <li *ngFor="let feature of fund.features">{{ feature }}</li>
                </ul>

                <a class="main-btn brochure-btn" [href]="fund.brochureUrl" target="_blank" rel="noopener">
                  تحميل الملف التعريفي الكامل (PDF)
                </a>
              </ng-container>
            </div>
          </div>

          <div class="subscription-info">
            <h4 class="section-subtitle">جهات تلقي الاكتتاب</h4>
            <ul class="channels-list">
              <li *ngFor="let channel of subscriptionChannels">{{ channel }}</li>
            </ul>

            <h4 class="section-subtitle">خطوات الاكتتاب</h4>
            <ol class="steps-list">
              <li *ngFor="let step of subscriptionSteps">{{ step }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
